import {
  Card,
  Divider,
  FileUploaderValidator,
  Space,
  Tabs,
  TextFieldValidator,
} from "@techzyapp/ui-lib";
import { useTranslation } from "hooks";

interface ISeoCard {
  image: any;
}

const SeoCard = ({ image }: ISeoCard) => {
  const { initilizeLanguageTabs } = useTranslation();

  return (
    <Card title="Search Engine Optimization (SEO)" icon="SearchNormal">
      <Tabs
        tabs={initilizeLanguageTabs(SeoTranslatableContent)}
        queryName="seoTab"
      />
      <Divider />
      <Space m="xl" />
      <Space>
        <FileUploaderValidator
          allowCrop
          key={image ? "loaded" : "empty"}
          title="OpenGraph Image"
          acceptedFileTypes={"image/*"}
          secondaryTitle="Recommended"
          secondaryTitleValue="800px - 600px (jpg)"
          name="seoOgImage"
          showAltTextAlert={false}
          allowReorder={false}
          initialFiles={
            Array.isArray(image) ? image : image ? [image] : undefined
          }
        />
      </Space>
    </Card>
  );
};

export default SeoCard;

interface ISeoTranslatableContent {
  languageCode: string;
}

const SeoTranslatableContent = ({ languageCode }: ISeoTranslatableContent) => {
  return (
    <div className="row">
      <div className="col-6 col-md-12">
        <Space>
          <TextFieldValidator
            label="Title"
            name={`translations.${languageCode}.seoTitle`}
          />
        </Space>
      </div>
      <div className="col-6 col-md-12">
        <Space>
          <TextFieldValidator
            label="Description"
            name={`translations.${languageCode}.seoDescription`}
            multiline
          />
        </Space>
      </div>
      <div className="col-6 col-md-12">
        <Space>
          <TextFieldValidator
            label="OpenGraph Title"
            name={`translations.${languageCode}.seoOgTitle`}
          />
        </Space>
      </div>
      <div className="col-6 col-md-12">
        <Space>
          <TextFieldValidator
            label="OpenGraph Description"
            name={`translations.${languageCode}.seoOgDescription`}
          />
        </Space>
      </div>
      <div className="col-6 col-md-12">
        <Space>
          <TextFieldValidator
            label="OpenGraph Url"
            name={`translations.${languageCode}.seoOgUrl`}
            iconName="Link"
            adornmentPosition="start"
          />
        </Space>
      </div>
      <div className="col-6 col-md-12">
        <Space>
          <TextFieldValidator
            label="Canonical"
            name={`translations.${languageCode}.seoCanonical`}
            iconName="Link"
            adornmentPosition="start"
          />
        </Space>
      </div>
      <div className="col-6 col-md-12">
        <Space>
          <TextFieldValidator
            label="Structured Data Markup (JSON-LD)"
            name={`translations.${languageCode}.seoStructuredDataMarkup`}
            multiline
          />
        </Space>
      </div>
    </div>
  );
};
